<template>
  <tr>
    <td>{{ item.Content }}</td>
    <td>{{ item.Time | dateFormat }}</td>
    <!-- 以下手機版不顯示 -->
    <!-- <td v-show="!isMobile">{{  }}</td> -->
    <!-- 以上手機版不顯示 -->
    <td>{{ item.Status }}</td>
    <td>    
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>
      <v-chip
        v-if="canApprove"
        color="red"
        small
      >待確認</v-chip>
      <v-chip
        v-if="canClose"
        color="red"
        small
      >待協調</v-chip>
      <v-chip
        v-if="canReviewBudget || canReviewReward || canReviewResult"
        color="red"
        small
      >待審核</v-chip>
      <v-chip
        v-if="canReport"
        color="red"
        small
      >待處理回報</v-chip>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import filterMixin from "@/data/filters/filter-mixin.vue";
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    canClose() {
      return (this.item.Status == "收受部門拒絕" || this.item.Status == "收受部門確認中" && moment(this.item.AlertTime) < moment()) && this.myLevel > 10;
    },
    canApprove() {
      return (
        this.item.Status == "收受部門確認中" &&
        this.myLevel == 10 &&
        this.myDepartment.ID == this.item.ReceivedDepartmentID
      );
    },
    canReviewBudget () {
      return (
        this.item.Status == "預算審核中" &&
        this.myLevel >= 1000
      );
    },
    canReviewReward () {
      return (
        this.item.Status == "獎金審核中" &&
        this.myLevel >= 1000
      );
    },
    canReviewResult () {
      return (
        (this.item.Status == "成果審核中" || this.item.Status == "獎金被退回") &&
        this.myLevel == 10 &&
        this.myDepartment.ID == this.item.InitiatedDepartmentID
      );
    },
    canReport () {
      return (
        (this.item.Status == "進行中" || this.item.Status == "退回成果") &&
        this.me.ID == this.item.UserID
      );
    },
    ...mapGetters(["me", "myLevel", "myDepartment"])
  },
  methods: {
    view() {
      let id = this.item.ID;
      this.$store.state.UI.dialog.workOrderDetail.id = id;
      this.$store.state.UI.dialog.workOrderDetail.isShow = true;
    }
  }
};
</script>